import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Beforeunload } from 'react-beforeunload';
import { useAppSelector } from '../redux/store';
import { isLocalhostEnvironment } from '../utils/utils';
/**
 * Once the user has gotten past the entry scene (and therefore should be logged in),
 * start showing the "before unload" alert box when they try to reload or leave the page.
 * TODO: Add tests?
 */
export const SceneBeforeUnloadContainer = () => {
    const sceneType = useAppSelector((state) => state.scene.sceneType);
    const isConnectionLost = useAppSelector((state) => state.session.isConnectionLost);
    const isBeforeUnloadDisabled = useAppSelector((state) => state.session.isBeforeUnloadDisabled);
    if (isLocalhostEnvironment()) {
        return null;
    }
    if (sceneType === 'entry') {
        // Only show unload alert once logged in (once past the 'entry' scene).
        return null;
    }
    if (isConnectionLost) {
        // User has lost connection (dialog should be shown to that effect) so there's no point in showing the unload alert.
        return null;
    }
    if (isBeforeUnloadDisabled) {
        // Before unload has been specifically disabled, for example just prior to an explicit reload of the page (logging out, for example).
        return null;
    }
    return _jsx(Beforeunload, { onBeforeunload: (event) => event.preventDefault() });
};
